import magnifiAPIInstance from "./apiInstance";

export const streamTemplateAPIs = {
  getRunningStreamTemplates: ({ payload }) =>
    magnifiAPIInstance.get(
      `/medialive/stream-templates/running?templateType=${payload?.templateType}&entityId=${payload?.entityId}&page_no=${payload?.pageNo}&search=${payload.search}`,
      payload,
    ),
};
